import { useRef, useState } from "react";
import { toast } from "sonner";
import { ImagePlus, Loader2 } from "lucide-react";
import { errText, readOrderImage, shrinkImage } from "@/lib/bf";

export const useImageRead = (onText) => {
  const [busy, setBusy] = useState(false);
  const read = async (file) => {
    if (!file || !file.type.startsWith("image/")) return toast.error("Alege o imagine (captură de ecran)");
    setBusy(true);
    try {
      const r = await readOrderImage(await shrinkImage(file));
      toast.success("Am citit captura. Verifică textul, apoi îl citesc cu AI.");
      onText(r.text);
    } catch (e) {
      toast.error(errText(e, "Nu am putut citi imaginea"));
    } finally {
      setBusy(false);
    }
  };
  return { busy, read };
};

export default function BFImageButton({ busy, onFile }) {
  const ref = useRef(null);
  return (
    <>
      <input ref={ref} type="file" accept="image/*" hidden onChange={(e) => { onFile(e.target.files?.[0]); e.target.value = ""; }} data-testid="bf-fo-image-input" />
      <button type="button" className="st-btn st-btn--ghost" onClick={() => ref.current?.click()} disabled={busy} data-testid="bf-fo-image">
        {busy ? <Loader2 size={14} className="animate-spin" /> : <ImagePlus size={14} />} {busy ? "Citesc captura…" : "Încarcă captură de ecran"}
      </button>
    </>
  );
}
